import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {UserRole} from 'classes/user-role';
import {Category} from 'shared/models/target-groups/category';
import {Company} from 'shared/models/target-groups/company';
import {Group} from 'shared/models/target-groups/group';
import {ManagementLevel} from 'shared/models/target-groups/management-level';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import { Question } from 'shared/models/questions/question';

@Injectable()
export class TargetGroupsDetailsRepository {

  constructor(private http: Http) { }

  public getTargetGroup(id: String): Observable<TargetGroup> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createTargetGroup(targetGroup: TargetGroup): Observable<TargetGroup> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(targetGroup);

    return this.http.post(`${environment.targetGroups.targetGroups}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateTargetGroup(targetGroup: TargetGroup): Observable<TargetGroup> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(targetGroup);

    return this.http.put(`${environment.targetGroups.targetGroups}/${targetGroup._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteTargetGroup(id: String): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.targetGroups.targetGroups}/${id}`, options)
      .map((response: Response) => {
        return response.ok;
      });
  }

  public getAllCategories(): Observable<Array<Category>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.categories}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllManagementLevel(): Observable<Array<ManagementLevel>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.managementLevel}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllRoles(): Observable<Array<UserRole>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.users}/roles`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllGroups(): Observable<Array<Group>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.groups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllFirstOrderTips(): Observable<Question> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.firstOrderTips}/rootquestions`, options)
      .map((response: Response) => {
        let rootQuestions: Array<Question> = response.json();
        return rootQuestions.find(question => question['systemName'] == 'tipStart');
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-details/repositories/target-groups-details.repository.ts